import React from 'react';
import clx from 'classnames';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

interface SummaryItemProps {
    text: number;
    type: string;
    onClick: () => void;
}

export default function SummaryItem(props: SummaryItemProps) {
    const {text, type, onClick} = props;
    const className = clx('qc-manager-bar__actions-item');

    return (
        <Box onClick={onClick} className={className}>
            <Typography variant="h6" className="qc-manager-bar__actions-item__number">
                {text}
            </Typography>
            <Typography variant="h6" className="qc-manager-bar__actions-item__title">
                {type}
            </Typography>
        </Box>
    );
}
